// src/theme/legacy/constants.ts
var SPACING_FACTOR = 4;
export { SPACING_FACTOR };